import React from 'react'

const SearchIcon = () => {
  return (
    <svg
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: 'pointer' }}
    >
      <path
        d="M5.89386 2.59863C4.2256 2.26894 2.5873 2.77846 1.4385 3.93738C0.509469 4.85652 0 6.08537 0 7.39415C0 8.70292 0.509469 9.93177 1.4385 10.8609C2.36753 11.79 3.59625 12.2996 4.90489 12.2996C5.94381 12.2996 6.92279 11.9799 7.76191 11.3804L10.6489 14.2677C10.9586 14.5774 11.4581 14.5774 11.7677 14.2677C12.0774 13.958 12.0774 13.4585 11.7677 13.1488L8.88075 10.2615C9.60999 9.24242 9.91967 8.00358 9.74984 6.72477C9.48013 4.69667 7.90177 2.99826 5.89386 2.59863ZM8.13153 6.66483C8.37128 7.81375 8.03163 8.9427 7.24246 9.74195C6.45328 10.5412 5.31446 10.8809 4.16566 10.6311C2.90697 10.3614 1.89802 9.32234 1.64828 8.06352C1.41852 6.89461 1.80812 5.79564 2.55734 5.05633C3.30656 4.31702 4.39542 3.9174 5.5642 4.14718C6.82289 4.39695 7.86181 5.406 8.13153 6.66483Z"
        fill="#808080"
      />
    </svg>
  )
}

export default SearchIcon
